/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Coming_Soon_TitleInputs */



/**
* | output |
* | --- |
* | "This feature will be available soon." |
*
* @param {Compliance_Copilot_Coming_Soon_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_coming_soon_title = /** @type {((inputs?: Compliance_Copilot_Coming_Soon_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Coming_Soon_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Funktion wird bald verfügbar sein.")
	return /** @type {LocalizedString} */ ("This feature will be available soon.")
});